// import React, { useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchEmployees, addEmployee, addSalary, updateEmployee, deleteEmployee, approveLeave, rejectLeave } from '../../redux/employer-employeeSlice/EmployerEmployeeSlice';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { BiPlus, BiCheck, BiX, BiEdit, BiTrash, BiDownload, BiDollar, BiSearch, BiEnvelope, BiMessageSquareDots, BiChat } from 'react-icons/bi';
// import Chart from 'chart.js/auto';
// import EmployerAttendance from './EmployerAttendance';
// import axios from 'axios';
// const EmployerEmployee = () => {
//   const dispatch = useDispatch();
//   const { employees, status } = useSelector(state => state.employerEmployee);
//   const { currentUser } = useSelector(state => state.user);
//   const employerId = currentUser?._id;
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isEditModalOpen, setIsEditModalOpen] = useState(false);
//   const [isPayslipModalOpen, setIsPayslipModalOpen] = useState(false);
//   const [isSalaryModalOpen, setIsSalaryModalOpen] = useState(false);
//   const [isSalaryHistoryModalOpen, setIsSalaryHistoryModalOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [salaryLoading, setSalaryLoading] = useState({});
//   const [charts, setCharts] = useState({});
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [editData, setEditData] = useState({});
//   const [payslipData, setPayslipData] = useState({});
//   const [selectedSalaryEmployee, setSelectedSalaryEmployee] = useState(null);
//   const [salaryFormData, setSalaryFormData] = useState({ grossSalary: '', tax: '', penalty: '', hmo: '', other: '' });
//   const [selectedHistoryEmployee, setSelectedHistoryEmployee] = useState(null);
//   const [isInitialFetchDone, setIsInitialFetchDone] = useState(false); // Flag for initial fetch
//     const [isSendPayslipModalOpen, setIsSendPayslipModalOpen] = useState(false);
//   const [sendMethod, setSendMethod] = useState('');
//   const [recipient, setRecipient] = useState('');
//   const [notification, setNotification] = useState({ message: '', type: '' });
//   const [isSending, setIsSending] = useState(false);

//   const [tinType, setTinType] = useState("");
//   const tinTypes = [
//   { value: "TIN", label: "TIN (Nigeria)" },
//   { value: "SSN", label: "SSN (United States)" },
//   { value: "NINO", label: "NINO (United Kingdom)" },
//   { value: "TFN", label: "TFN (Australia)" },
//   { value: "SIN", label: "SIN (Canada)" },
//   { value: "PAN", label: "PAN (India)" },
//   { value: "CPF", label: "CPF (Brazil)" },
//   { value: "DNI", label: "DNI (Spain)" },
// ];


//   useEffect(() => {
//     if (employerId && !isInitialFetchDone) {
//       console.log('Initial fetch triggered for employerId:', employerId, 'status:', status);
//       const userType = currentUser.userType || 'jobEmployer';
//       const id = userType === 'jobEmployer' ? (currentUser.employerId || employerId) : currentUser._id;
//       dispatch(fetchEmployees({ id, userType })).then(() => {
//         setIsInitialFetchDone(true); // Set flag after successful fetch
//         console.log('Initial fetch completed, status:', status);
//       }).catch((error) => {
//         console.error('Initial fetch failed:', error);
//       });
//     }
//   }, [employerId, currentUser.userType, currentUser._id, currentUser.employerId, dispatch, isInitialFetchDone]);

//   useEffect(() => {
//     if (employees.length > 0) {
//       createCharts();
//     }
//     console.log('Employees updated:', employees);
//   }, [employees]);

//   const handleAddEmployee = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     const formData = { employerId, ...Object.fromEntries(new FormData(e.target)) };
//     try {
//       await dispatch(addEmployee(formData)).unwrap();
//       setIsModalOpen(false);
//       toast.success('Employee added successfully!');
//       // Manual refresh without affecting useEffect
//       dispatch(fetchEmployees({ id: employerId, userType: 'jobEmployer' }));
//     } catch (error) {
//       toast.error('Failed to add employee: ' + error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAddSalary = async (e) => {
//     e.preventDefault();
//     setSalaryLoading(prev => ({ ...prev, [selectedSalaryEmployee._id]: true }));
//     const formData = { employerId, employeeId: selectedSalaryEmployee._id, ...salaryFormData };
//     try {
//       await dispatch(addSalary(formData)).unwrap();
//       setIsSalaryModalOpen(false);
//       setSalaryFormData({ grossSalary: '', tax: '', penalty: '', hmo: '', other: '' });
//       toast.success('Salary added successfully!');
//       // Manual refresh
//       dispatch(fetchEmployees({ id: employerId, userType: 'jobEmployer' }));
//     } catch (error) {
//       toast.error('Failed to add salary: ' + error.message);
//     } finally {
//       setSalaryLoading(prev => ({ ...prev, [selectedSalaryEmployee._id]: false }));
//     }
//   };

//   const handleUpdateEmployee = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       await dispatch(updateEmployee({ employerId, employeeId: editData._id, ...editData })).unwrap();
//       setIsEditModalOpen(false);
//       toast.success('Employee updated successfully!');
//       // Manual refresh
//       dispatch(fetchEmployees({ id: employerId, userType: 'jobEmployer' }));
//     } catch (error) {
//       toast.error('Failed to update employee: ' + error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDeleteEmployee = async (employeeId) => {
//     if (window.confirm('Are you sure you want to delete this employee?')) {
//       try {
//         await dispatch(deleteEmployee({ employerId, employeeId })).unwrap();
//         toast.success('Employee deleted successfully!');
//         // Manual refresh
//         dispatch(fetchEmployees({ id: employerId, userType: 'jobEmployer' }));
//       } catch (error) {
//         toast.error('Failed to delete employee: ' + error.message);
//       }
//     }
//   };

//   const handleGeneratePayslip = (employee) => {
//     setPayslipData({
//       employee: `${employee.firstName} ${employee.lastName}`,
//       salary: employee.salary.history[employee.salary.history.length - 1] || {},
//     });
//     setIsPayslipModalOpen(true);
//   };

//   const createCharts = () => {
//     const ctxStaff = document.getElementById('staffChart')?.getContext('2d');
//     const ctxSalary = document.getElementById('salaryChart')?.getContext('2d');

//     if (ctxStaff && !charts.staff) {
//       charts.staff = new Chart(ctxStaff, {
//         type: 'pie',
//         data: {
//           labels: employees.map(e => `${e.firstName} ${e.lastName}`),
//           datasets: [{
//             label: 'Employee Distribution',
//             data: employees.map(() => 1),
//             backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF'],
//           }],
//         },
//         options: { responsive: true, maintainAspectRatio: false },
//       });
//     }

//     if (ctxSalary && !charts.salary) {
//       const totalSalaries = employees?.map(e => e.salary?.history.reduce((sum, hist) => sum + (hist.netSalary || 0), 0) || 0);
//       charts.salary = new Chart(ctxSalary, {
//         type: 'pie',
//         data: {
//           labels: employees.map(e => `${e.firstName} ${e.lastName}`),
//           datasets: [{
//             label: 'Salary Payments',
//             data: totalSalaries,
//             backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF'],
//           }],
//         },
//         options: { responsive: true, maintainAspectRatio: false },
//       });
//     }
//     setCharts({ ...charts });
//   };

//   const calculateBreakdown = (salary) => {
//     const daily = (salary.netSalary || 0) / 30;
//     const weekly = daily * 7;
//     const monthly = salary.netSalary || 0;
//     return { daily, weekly, monthly };
//   };

//     const attendanceEmployeeList = employees.map(emp => ({
//     id: emp._id,
//     name: `${emp.firstName} ${emp.lastName}` || `Employee ${emp._id.slice(-4)}`,
//   }));
//   const generatePayslipData = (employee, history = null) => {
//     if (!employee?.salary) {
//       return { employee: 'N/A', salary: { grossSalary: 0, deductions: {}, netSalary: 0 } };
//     }
//     if (history) {
//       return {
//         employee: `${employee.firstName} ${employee.lastName}`,
//         salary: {
//           grossSalary: history.grossSalary || 0,
//           deductions: history.deductions || { tax: 0, penalty: 0, hmo: 0, other: 0 },
//           netSalary: history.netSalary || 0,
//         },
//       };
//     }
//     const { gross, deductions, net, history: latestHistory } = employee.salary;
//     const latest = latestHistory?.length ? latestHistory[latestHistory.length - 1] : {};
//     return {
//       employee: `${employee.firstName} ${employee.lastName}`,
//       salary: {
//         grossSalary: gross || latest.grossSalary || 0,
//         deductions: deductions || latest.deductions || { tax: 0, penalty: 0, hmo: 0, other: 0 },
//         netSalary: net || latest.netSalary || 0,
//       },
//     };
//   };

//   const handleSendPayslipEmail = async (employee) => {
//     if (!employee?.email) {
//       setNotification({ message: 'Employee email not available', type: 'error' });
//       return;
//     }

//     setIsSending(true);
//     setNotification({ message: '', type: '' });

//     const payslipData = generatePayslipData(employee);
//     const payslipText = `Payslip for ${payslipData.employee}\nGross: ₦${(payslipData.salary.grossSalary || 0).toLocaleString()}\nDeductions: ₦${Object.values(payslipData.salary.deductions || {})
//       .reduce((a, b) => a + b, 0)
//       .toLocaleString()}\nNet: ₦${(payslipData.salary.netSalary || 0).toLocaleString()}`;

//     try {
//       await axios.post(`${process.env.REACT_APP_API_URL}payslip/send-email`,
//         {
//           recipient: employee.email,
//           subject: `Payslip for ${payslipData.employee}`,
//           body: payslipText,
//           employeeId: employee._id,
//         },
//         {
//           headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//         }
//       );
//       setNotification({ message: 'Payslip sent via email successfully', type: 'success' });
//     } catch (err) {
//       console.error('Error sending payslip email:', err);
//       setNotification({ message: err.message || 'Failed to send payslip via email', type: 'error' });
//     } finally {
//       setIsSending(false);
//     }
//   };





//    const handleSendPayslip = async () => {
//     if (!selectedEmployee || !recipient || !sendMethod) {
//       setNotification({ message: 'Please provide a recipient and select a method', type: 'error' });
//       return;
//     }

//     setIsSending(true);
//     const payslipData = generatePayslipData(selectedEmployee);
//     const payslipText = `Payslip for ${payslipData.employee}\nGross: N${(payslipData.salary.grossSalary || 0).toLocaleString()}\nDeductions: N${Object.values(payslipData.salary.deductions || {})
//       .reduce((a, b) => a + b, 0)
//       .toLocaleString()}\nNet: N${(payslipData.salary.netSalary || 0).toLocaleString()}`;

//     try {
//       if (sendMethod === 'email') {
//         await axios.post(
//           '/api/payslip/send-email',
//           {
//             recipient,
//             subject: `Payslip for ${payslipData.employee}`,
//             body: payslipText,
//             employeeId: selectedEmployee._id,
//           },
//           {
//             headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//           }
//         );
//         setNotification({ message: 'Payslip sent via email successfully', type: 'success' });
//       } else if (sendMethod === 'whatsapp' || sendMethod === 'sms') {
//         const kudiSMSResponse = await axios.post(
//           'https://api.kudisms.net/v1/sms/send', // Adjust to KudiSMS WhatsApp/SMS endpoint
//           {
//             public_key: process.env.REACT_APP_KUDISMS_PUBLIC_KEY,
//             secret_key: process.env.REACT_APP_KUDISMS_SECRET_KEY,
//             recipient,
//             message: sendMethod === 'whatsapp' ? payslipText : `Payslip: ${payslipText}`,
//             sender_id: 'YourBusinessName', // Replace with your KudiSMS sender ID
//             type: sendMethod === 'whatsapp' ? 'whatsapp' : 'sms',
//           },
//           {
//             headers: { 'Content-Type': 'application/json' },
//           }
//         );

//         if (kudiSMSResponse.data.status === 'success') {
//           setNotification({ message: `Payslip sent via ${sendMethod} successfully`, type: 'success' });
//         } else {
//           throw new Error('KudiSMS API error');
//         }
//       }
//     } catch (err) {
//       console.error(`Error sending payslip via ${sendMethod}:`, err);
//       setNotification({ message: `Failed to send payslip via ${sendMethod}`, type: 'error' });
//     } finally {
//       setIsSending(false);
//       setIsSendPayslipModalOpen(false);
//       setRecipient('');
//       setSendMethod('');
//       setSelectedEmployee(null);
//     }
//   };

//    // Clear notification after 5 seconds
//   useEffect(() => {
//     if (notification.message) {
//       const timer = setTimeout(() => {
//         setNotification({ message: '', type: '' });
//       }, 5000);
//       return () => clearTimeout(timer);
//     }
//   }, [notification]);



//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       <h2 className="text-3xl font-bold text-gray-800 mb-6">Manage Employees</h2>
//       <button
//         onClick={() => setIsModalOpen(true)}
//         className="mb-6 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
//       >
//         <BiPlus /> Add Employee
//       </button>

//             <EmployerAttendance employeeList={attendanceEmployeeList} />

//       {isModalOpen && (
//         <div className="fixed h-50 inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
//             <div className="flex justify-between items-center mb-4">
//               <h3 className="text-xl font-semibold">Add New Employee</h3>
//               <button onClick={() => setIsModalOpen(false)} className="text-gray-500 hover:text-gray-700">
//                 <BiX size={24} />
//               </button>
//             </div>
//             <form onSubmit={handleAddEmployee} className="space-y-4">
//               <input name="firstName" placeholder="First Name" required className="w-full p-2 border rounded" />
//               <input name="lastName" placeholder="Last Name" required className="w-full p-2 border rounded" />
//               <input name="email" placeholder="Email" required className="w-full p-2 border rounded" />
//               <input name="gender" placeholder="Gender" required className="w-full p-2 border rounded" />
//               <input name="middleName" placeholder="Middle Name" className="w-full p-2 border rounded" />
//               <input name="dateOfBirth" placeholder="Date of Birth" className="w-full p-2 border rounded" />
//               <input name="address" placeholder="Address" className="w-full p-2 border rounded" />
//               <input name="phoneNumber" placeholder="Phone Number" className="w-full p-2 border rounded" />
//               <input name="TIN" placeholder="TIN" className="w-full p-2 border rounded" />
//                              <select

 
//     name="TINType"
// className="w-full p-2 border rounded" 
   
//   >
//     <option value="" disabled>
//       Select TIN type
//     </option>
//     {tinTypes.map((type) => (
//       <option key={type.value} value={type.value}>
//         {type.label}
//       </option>
//     ))}
//   </select>
//               <input name="TINType" placeholder="TINType" className="w-full p-2 border rounded" />
//               <input name="whatsappNumber" placeholder="WhatsApp Number" className="w-full p-2 border rounded" />
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="w-full bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors flex items-center justify-center gap-2"
//               >
//                 {loading ? (
//                   <>
//                     <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
//                     Adding...
//                   </>
//                 ) : 'Add Employee'}
//               </button>
//             </form>
//           </div>
//         </div>
//       )}

//       {isEditModalOpen && selectedEmployee && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
//             <div className="flex justify-between items-center mb-4">
//               <h3 className="text-xl font-semibold">Edit Employee</h3>
//               <button onClick={() => setIsEditModalOpen(false)} className="text-gray-500 hover:text-gray-700">
//                 <BiX size={24} />
//               </button>
//             </div>
     
//             <form onSubmit={handleUpdateEmployee} className="space-y-4">
//               <input name="firstName" value={editData.firstName || ''} onChange={(e) => setEditData({ ...editData, firstName: e.target.value })} required className="w-full p-2 border rounded" />
//               <input name="lastName" value={editData.lastName || ''} onChange={(e) => setEditData({ ...editData, lastName: e.target.value })} required className="w-full p-2 border rounded" />
//               <input name="email" value={editData.email || ''} onChange={(e) => setEditData({ ...editData, email: e.target.value })} required className="w-full p-2 border rounded" />
//               <input name="gender" value={editData.gender || ''} onChange={(e) => setEditData({ ...editData, gender: e.target.value })} required className="w-full p-2 border rounded" />
//               <input name="middleName" value={editData.middleName || ''} onChange={(e) => setEditData({ ...editData, middleName: e.target.value })} className="w-full p-2 border rounded" />
//               <input name="dateOfBirth" value={editData.dateOfBirth || ''} onChange={(e) => setEditData({ ...editData, dateOfBirth: e.target.value })} className="w-full p-2 border rounded" />
//               <input name="address" value={editData.address || ''} onChange={(e) => setEditData({ ...editData, address: e.target.value })} className="w-full p-2 border rounded" />
//               <input name="phoneNumber" value={editData.phoneNumber || ''} onChange={(e) => setEditData({ ...editData, phoneNumber: e.target.value })} className="w-full p-2 border rounded" />



//                 <select
//     value={tinType}
//    onChange={(e) => setEditData({ ...editData, TINType: e.target.value })}
//     name="TINType"
// className="w-full p-2 border rounded" 
   
//   >
//     <option value="" disabled>
//       Select TIN type
//     </option>
//     {tinTypes.map((type) => (
//       <option key={type.value} value={type.value}>
//         {type.label}
//       </option>
//     ))}
//   </select>
//               {/* <input name="TINType" value={editData.TINType || ''} onChange={(e) => setEditData({ ...editData, TINType: e.target.value })} className="w-full p-2 border rounded" /> */}
//               <input name="TIN" value={editData.TIN || ''} onChange={(e) => setEditData({ ...editData, TIN: e.target.value })} className="w-full p-2 border rounded" />
//               <input name="whatsappNumber" value={editData.whatsappNumber || ''} onChange={(e) => setEditData({ ...editData, whatsappNumber: e.target.value })} className="w-full p-2 border rounded" />
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="w-full bg-yellow-600 text-white px-4 py-2 rounded-lg hover:bg-yellow-700 transition-colors flex items-center justify-center gap-2"
//               >
//                 {loading ? (
//                   <>
//                     <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
//                     Updating...
//                   </>
//                 ) : 'Update Employee'}
//               </button>
//             </form>
//           </div>
//         </div>
//       )}

//       {isPayslipModalOpen && payslipData.employee && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
//             <div className="flex justify-between items-center mb-4">
//               <h3 className="text-xl font-semibold">Payslip</h3>
//               <button onClick={() => setIsPayslipModalOpen(false)} className="text-gray-500 hover:text-gray-700">
//                 <BiX size={24} />
//               </button>
//             </div>
//             <div className="space-y-4">
//               <p><strong>Employee:</strong> {payslipData.employee}</p>
//               <p><strong>Gross Salary:</strong> N{payslipData.salary.grossSalary || 0}</p>
//               <p><strong>Deductions:</strong> N{Object.values(payslipData.salary.deductions || {}).reduce((a, b) => a + b, 0)}</p>
//               <p><strong>Net Salary:</strong> N{payslipData.salary.netSalary || 0}</p>
//               <div>
//                 <strong>Breakdown:</strong>
//                 <table className="w-full mt-2">
//                   <thead className="bg-gray-100">
//                     <tr><th className="py-1 px-2">Type</th><th className="py-1 px-2">Amount</th></tr>
//                   </thead>
//                   <tbody>
//                     {Object.entries(calculateBreakdown(payslipData.salary)).map(([type, amount]) => (
//                       <tr key={type} className="border-t">
//                         <td className="py-1 px-2 capitalize">{type}</td>
//                         <td className="py-1 px-2">${amount.toFixed(2)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//               <button
//                 onClick={() => {
//                   const element = document.createElement('a');
//                   const file = new Blob([`Payslip for ${payslipData.employee}\nGross: $${payslipData.salary.grossSalary || 0}\nDeductions: $${Object.values(payslipData.salary.deductions || {}).reduce((a, b) => a + b, 0)}\nNet: $${payslipData.salary.netSalary || 0}`], { type: 'text/plain' });
//                   element.href = URL.createObjectURL(file);
//                   element.download = `payslip_${payslipData.employee.replace(/ /g, '_')}.txt`;
//                   document.body.appendChild(element);
//                   element.click();
//                   document.body.removeChild(element);
//                 }}
//                 className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
//               >
//                 <BiDownload /> Download Payslip
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {isSalaryModalOpen && selectedSalaryEmployee && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
//             <div className="flex justify-between items-center mb-4">
//               <h3 className="text-xl font-semibold">Add Salary for {selectedSalaryEmployee.firstName} {selectedSalaryEmployee.lastName}</h3>
//               <button onClick={() => setIsSalaryModalOpen(false)} className="text-gray-500 hover:text-gray-700">
//                 <BiX size={24} />
//               </button>
//             </div>
//             <form onSubmit={handleAddSalary} className="space-y-4">
//               <input
//                 name="grossSalary"
//                 value={salaryFormData.grossSalary}
//                 onChange={(e) => setSalaryFormData({ ...salaryFormData, grossSalary: e.target.value })}
//                 placeholder="Gross Salary"
//                 type="number"
//                 required
//                 className="w-full p-2 border rounded"
//               />
//               <input
//                 name="tax"
//                 value={salaryFormData.tax}
//                 onChange={(e) => setSalaryFormData({ ...salaryFormData, tax: e.target.value })}
//                 placeholder="Tax"
//                 type="number"
//                 className="w-full p-2 border rounded"
//               />
//               <input
//                 name="penalty"
//                 value={salaryFormData.penalty}
//                 onChange={(e) => setSalaryFormData({ ...salaryFormData, penalty: e.target.value })}
//                 placeholder="Penalty"
//                 type="number"
//                 className="w-full p-2 border rounded"
//               />
//               <input
//                 name="hmo"
//                 value={salaryFormData.hmo}
//                 onChange={(e) => setSalaryFormData({ ...salaryFormData, hmo: e.target.value })}
//                 placeholder="HMO"
//                 type="number"
//                 className="w-full p-2 border rounded"
//               />
//               <input
//                 name="other"
//                 value={salaryFormData.other}
//                 onChange={(e) => setSalaryFormData({ ...salaryFormData, other: e.target.value })}
//                 placeholder="Other Deductions"
//                 type="number"
//                 className="w-full p-2 border rounded"
//               />
//               <button
//                 type="submit"
//                 disabled={salaryLoading[selectedSalaryEmployee._id]}
//                 className="w-full bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
//               >
//                 {salaryLoading[selectedSalaryEmployee._id] ? (
//                   <>
//                     <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
//                     Adding...
//                   </>
//                 ) : 'Add Salary'}
//               </button>
//             </form>
//           </div>
//         </div>
//       )}

//       {isSalaryHistoryModalOpen && selectedHistoryEmployee && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-2xl">
//             <div className="flex justify-between items-center mb-4">
//               <h3 className="text-xl font-semibold">Salary History & Breakdown for {selectedHistoryEmployee.firstName} {selectedHistoryEmployee.lastName}</h3>
//               <button onClick={() => setIsSalaryHistoryModalOpen(false)} className="text-gray-500 hover:text-gray-700">
//                 <BiX size={24} />
//               </button>
//             </div>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <table className="w-full text-sm md:text-base">
//                 <thead className="bg-gray-100"><tr><th className="py-2 px-4">Period</th><th className="py-2 px-4">Gross</th><th className="py-2 px-4">Deductions</th><th className="py-2 px-4">Net</th></tr></thead>
//                 <tbody>
//                   {selectedHistoryEmployee.salary.history.map((hist, i) => (
//                     <tr key={i} className="border-t">
//                       <td className="py-2 px-4">{hist.month} {hist.year}</td>
//                       <td className="py-2 px-4">N{hist.grossSalary.toFixed(2)}</td>
//                       <td className="py-2 px-4">N{Object.values(hist.deductions).reduce((a, b) => a + b, 0).toFixed(2)}</td>
//                       <td className="py-2 px-4">N{hist.netSalary.toFixed(2)}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//               <table className="w-full text-sm md:text-base">
//                 <thead className="bg-gray-100"><tr><th className="py-2 px-4">Type</th><th className="py-2 px-4">Amount</th></tr></thead>
//                 <tbody>
//                   {Object.entries(calculateBreakdown(selectedHistoryEmployee.salary.history[selectedHistoryEmployee.salary.history.length - 1] || {})).map(([type, amount]) => (
//                     <tr key={type} className="border-t">
//                       <td className="py-2 px-4 capitalize">{type}</td>
//                       <td className="py-2 px-4">N{amount.toFixed(2)}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}

//         {/* Notification Toast */}
//         {notification.message && (
//           <div
//             className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg text-white ${
//               notification.type === 'success' ? 'bg-green-500' : 'bg-red-500'
//             }`}
//           >
//             {notification.message}
//           </div>
//         )}

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
//         <div className="bg-white p-4 rounded-lg shadow-lg">
//           <h3 className="text-lg font-semibold mb-2">Employee Distribution</h3>
//           <div className="h-64">
//             <canvas id="staffChart"></canvas>
//           </div>
//         </div>
//         <div className="bg-white p-4 rounded-lg shadow-lg">
//           <h3 className="text-lg font-semibold mb-2">Salary Payments</h3>
//           <div className="h-64">
//             <canvas id="salaryChart"></canvas>
//           </div>
//         </div>
//       </div>

//       <div className="bg-white p-6 rounded-lg shadow-lg mb-6">
//         <h3 className="text-xl font-semibold mb-4">Employed workers & Salaries</h3>
//         <table className="w-full text-sm md:text-base">
//           <thead className="bg-gray-100">
//             <tr>
//               <th className="py-2 px-4 text-left">Name</th>
//               <th className="py-2 px-4 text-left">Email</th>
//               <th className="py-2 px-4 text-left">Latest Net Salary</th>
//               <th className="py-2 px-4 text-left">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {employees.map(employee => (
//               <tr key={employee._id} className="border-t">
//                 <td className="py-2 px-4">{employee.firstName} {employee.lastName}</td>
//                 <td className="py-2 px-4">{employee.email}</td>
//                 <td className="py-2 px-4">N{(employee.salary?.history[employee.salary?.history.length - 1]?.netSalary || 0).toFixed(2)}</td>
//                 <td className="py-2 px-6">
//                   <button onClick={() => { setSelectedEmployee(employee); setEditData(employee); setIsEditModalOpen(true); }} className="text-blue-600 hover:text-blue-800 mr-2"><BiEdit /></button>
//                   <button onClick={() => handleDeleteEmployee(employee._id)} className="text-red-600 hover:text-red-800"><BiTrash /></button>
//                   <button onClick={() => handleGeneratePayslip(employee)} className="text-green-600 hover:text-green-800 ml-2"><BiDownload /></button>
//                   <button onClick={() => { setSelectedSalaryEmployee(employee); setIsSalaryModalOpen(true); }} className="text-purple-600 hover:text-purple-800 ml-2"><BiDollar /></button>
//                   <button onClick={() => { setSelectedHistoryEmployee(employee); setIsSalaryHistoryModalOpen(true); }} className="text-teal-600 hover:text-teal-800 ml-2"><BiSearch /></button>
                   
//   <button
//     onClick={() => handleSendPayslipEmail(employee)}
//     disabled={isSending}
//     className={`text-blue-600 hover:text-blue-800 ${isSending ? 'opacity-50 cursor-not-allowed' : ''}`}
//   >
//     <BiEnvelope />
//   </button>
//                           {/* <button
//                             onClick={() => {
//                               setSelectedEmployee(employee);
//                               setSendMethod('whatsapp');
//                               setIsSendPayslipModalOpen(true);
//                             }}
//                             className="text-green-600 hover:text-green-800"
//                           >
//                             <BiMessageSquareDots />
//                           </button>
//                           <button
//                             onClick={() => {
//                               setSelectedEmployee(employee);
//                               setSendMethod('sms');
//                               setIsSendPayslipModalOpen(true);
//                             }}
//                             className="text-teal-600 hover:text-teal-800"
//                           >
//                             <BiChat />
//                           </button> */}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {employees.map(employee => (
//         <div key={employee._id} className="bg-white p-6 rounded-lg shadow-lg mb-6">
//           <h3 className="text-xl font-semibold mb-4">{employee.firstName} {employee.lastName} - Salary Breakdown</h3>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//             <table className="w-full text-sm md:text-base">
//               <thead className="bg-gray-100"><tr><th className="py-2 px-4">Period</th><th className="py-2 px-4">Gross</th><th className="py-2 px-4">Deductions</th><th className="py-2 px-4">Net</th></tr></thead>
//               <tbody>
//                 {employee.salary?.history.map((hist, i) => (
//                   <tr key={i} className="border-t">
//                     <td className="py-2 px-4">{hist.month} {hist.year}</td>
//                     <td className="py-2 px-4">N{hist.grossSalary.toFixed(2)}</td>
//                     <td className="py-2 px-4">N{Object.values(hist.deductions).reduce((a, b) => a + b, 0).toFixed(2)}</td>
//                     <td className="py-2 px-4">N{hist.netSalary.toFixed(2)}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             <table className="w-full text-sm md:text-base">
//               <thead className="bg-gray-100"><tr><th className="py-2 px-4">Type</th><th className="py-2 px-4">Amount</th></tr></thead>
//               <tbody>
//                 {Object.entries(calculateBreakdown(employee.salary?.history[employee.salary?.history.length - 1] || {})).map(([type, amount]) => (
//                   <tr key={type} className="border-t">
//                     <td className="py-2 px-4 capitalize">{type}</td>
//                     <td className="py-2 px-4">N{amount.toFixed(2)}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <h4 className="text-lg font-semibold mb-2">Leave History</h4>
//           <table className="w-full text-sm md:text-base">
//             <thead className="bg-gray-100">
//               <tr>
//                 <th className="py-2 px-4 text-left">Start Date</th>
//                 <th className="py-2 px-4 text-left">End Date</th>
//                 <th className="py-2 px-4 text-left">Reason</th>
//                 <th className="py-2 px-4 text-left">Status</th>
//                 <th className="py-2 px-4 text-left">Actions</th>
              

//               </tr>
//             </thead>
//             <tbody>
//               {employee.leaveRequests?.map(leave => (
//                 <tr key={leave._id} className="border-t">
//                   <td className="py-2 px-4">{new Date(leave.startDate).toLocaleDateString()}</td>
//                   <td className="py-2 px-4">{new Date(leave.endDate).toLocaleDateString()}</td>
//                   <td className="py-2 px-4">{leave.reason}</td>
               
//                   <td className="py-2 px-4">{leave.status}</td>
               
//                   <td className="py-2 px-4">
//                     {leave.status === 'Pending' && (
//                       <>
//                         <button onClick={() => dispatch(approveLeave({ employerId, employeeId: employee._id, leaveId: leave._id })).unwrap().then(() => toast.success('Leave approved!'))} className="text-green-600 hover:text-green-800 mr-2"><BiCheck /></button>
//                         <button onClick={() => dispatch(rejectLeave({ employerId, employeeId: employee._id, leaveId: leave._id })).unwrap().then(() => toast.success('Leave rejected!'))} className="text-red-600 hover:text-red-800"><BiX /></button>
//                       </>
//                     )}
//                   </td>
//                      <td className="py-2 px-4">{leave.others}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       ))}


//     </div>
//   );
// };

// export default EmployerEmployee;

// const calculateBreakdown = (salary) => {
//   const daily = (salary.netSalary || 0) / 30;
//   const weekly = daily * 7;
//   const monthly = salary.netSalary || 0;
//   return { daily, weekly, monthly };
// };


















import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEmployees, addEmployee, addSalary, updateEmployee, deleteEmployee, approveLeave, rejectLeave } from '../../redux/employer-employeeSlice/EmployerEmployeeSlice';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BiPlus, BiCheck, BiX, BiEdit, BiTrash, BiDownload, BiDollar, BiSearch, BiEnvelope } from 'react-icons/bi';
import Chart from 'chart.js/auto';
import { CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, LineElement, PointElement } from 'chart.js';
import EmployerAttendance from './EmployerAttendance';
import axios from 'axios';

// Register Chart.js components
Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, LineElement, PointElement);

const EmployerEmployee = () => {
  const dispatch = useDispatch();
  const { employees, status } = useSelector(state => state.employerEmployee);
  const { currentUser } = useSelector(state => state.user);
  const employerId = currentUser?._id;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isPayslipModalOpen, setIsPayslipModalOpen] = useState(false);
  const [isSalaryModalOpen, setIsSalaryModalOpen] = useState(false);
  const [isSalaryHistoryModalOpen, setIsSalaryHistoryModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [salaryLoading, setSalaryLoading] = useState({});
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [editData, setEditData] = useState({});
  const [payslipData, setPayslipData] = useState({});
  const [selectedSalaryEmployee, setSelectedSalaryEmployee] = useState(null);
  const [salaryFormData, setSalaryFormData] = useState({ grossSalary: '', tax: '', penalty: '', hmo: '', other: '' });
  const [selectedHistoryEmployee, setSelectedHistoryEmployee] = useState(null);
  const [isInitialFetchDone, setIsInitialFetchDone] = useState(false);
  const [isSendPayslipModalOpen, setIsSendPayslipModalOpen] = useState(false);
  const [sendMethod, setSendMethod] = useState('');
  const [recipient, setRecipient] = useState('');
  const [notification, setNotification] = useState({ message: '', type: '' });
  const [isSending, setIsSending] = useState(false);
  const chartRefs = useRef({}); // Store chart instances in a ref to avoid state update issues

  const [tinType, setTinType] = useState("");
  const tinTypes = [
    { value: "TIN", label: "TIN (Nigeria)" },
    { value: "SSN", label: "SSN (United States)" },
    { value: "NINO", label: "NINO (United Kingdom)" },
    { value: "TFN", label: "TFN (Australia)" },
    { value: "SIN", label: "SIN (Canada)" },
    { value: "PAN", label: "PAN (India)" },
    { value: "CPF", label: "CPF (Brazil)" },
    { value: "DNI", label: "DNI (Spain)" },
  ];

  useEffect(() => {
    if (employerId && !isInitialFetchDone) {
      const userType = currentUser.userType || 'jobEmployer';
      const id = userType === 'jobEmployer' ? (currentUser.employerId || employerId) : currentUser._id;
      dispatch(fetchEmployees({ id, userType })).then(() => {
        setIsInitialFetchDone(true);
      }).catch((error) => {
        console.error('Initial fetch failed:', error);
      });
    }
  }, [employerId, currentUser.userType, currentUser._id, currentUser.employerId, dispatch, isInitialFetchDone]);

  useEffect(() => {
    if (employees.length > 0) {
      createCharts();
    }
    // Cleanup charts on component unmount
    return () => {
      Object.values(chartRefs.current).forEach(chart => chart?.destroy());
      chartRefs.current = {};
    };
  }, [employees]);

  const createCharts = () => {
    // Destroy all existing charts
    Object.values(chartRefs.current).forEach(chart => {
      if (chart) {
        chart.destroy();
      }
    });
    chartRefs.current = {};

    // Pie Chart for Employee Distribution
    const ctxStaff = document.getElementById('staffChart')?.getContext('2d');
    if (ctxStaff) {
      chartRefs.current.staff = new Chart(ctxStaff, {
        type: 'pie',
        data: {
          labels: employees.map(e => `${e.firstName} ${e.lastName}`),
          datasets: [{
            label: 'Employee Distribution',
            data: employees.map(() => 1),
            backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#FFCD56'],
          }],
        },
        options: { responsive: true, plugins: { legend: { position: 'top' } } },
      });
    }

    // Bar Chart for Total Salaries
    const ctxSalaryBar = document.getElementById('salaryBarChart')?.getContext('2d');
    if (ctxSalaryBar) {
      const totalSalaries = employees.map(e => e.salary?.history.reduce((sum, hist) => sum + (hist.netSalary || 0), 0) || 0);
      chartRefs.current.salaryBar = new Chart(ctxSalaryBar, {
        type: 'bar',
        data: {
          labels: employees.map(e => `${e.firstName} ${e.lastName}`),
          datasets: [{
            label: 'Total Salary Paid',
            data: totalSalaries,
            backgroundColor: 'rgba(75, 192, 192, 0.6)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1,
          }],
        },
        options: { responsive: true, scales: { y: { beginAtZero: true } } },
      });
    }

    // Waterfall Chart Simulation for Average Salary Breakdown
    const averageGross = employees.reduce((sum, e) => sum + (e.salary?.gross || 0), 0) / employees.length || 0;
    const averageDeductions = employees.reduce((sum, e) => sum + Object.values(e.salary?.deductions || {}).reduce((a, b) => a + b, 0), 0) / employees.length || 0;
    const averageNet = averageGross - averageDeductions;

    const waterfallData = [
      { label: 'Gross', value: [0, averageGross] },
      { label: 'Deductions', value: [averageGross, averageGross - averageDeductions] },
      { label: 'Net', value: [averageGross - averageDeductions, averageNet] },
    ];

    const ctxWaterfall = document.getElementById('waterfallChart')?.getContext('2d');
    if (ctxWaterfall) {
      chartRefs.current.waterfall = new Chart(ctxWaterfall, {
        type: 'bar',
        data: {
          labels: waterfallData.map(d => d.label),
          datasets: [{
            label: 'Salary Breakdown',
            data: waterfallData.map(d => d.value),
            backgroundColor: ['#4CAF50', '#F44336', '#2196F3'],
          }],
        },
        options: {
          responsive: true,
          plugins: { legend: { display: false } },
          scales: {
            y: { beginAtZero: true },
            x: { stacked: true },
          },
        },
      });
    }

    // Line Chart for Salary Trends
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const averageSalariesByMonth = months.map((_, i) => 
      employees.reduce((sum, e) => sum + (e.salary?.history.find(h => h.month === months[i])?.netSalary || 0), 0) / employees.length || 0
    );

    const ctxLine = document.getElementById('lineChart')?.getContext('2d');
    if (ctxLine) {
      chartRefs.current.line = new Chart(ctxLine, {
        type: 'line',
        data: {
          labels: months,
          datasets: [{
            label: 'Average Monthly Salary Trend',
            data: averageSalariesByMonth,
            borderColor: '#FF6384',
            tension: 0.1,
            fill: false,
          }],
        },
        options: { responsive: true, scales: { y: { beginAtZero: true } } },
      });
    }

    // Rainbow Stacked Bar Chart for Deductions Breakdown
    const deductionTypes = ['tax', 'penalty', 'hmo', 'other'];
    const rainbowColors = ['#FF0000', '#FF7F00', '#FFFF00', '#00FF00', '#0000FF', '#4B0082', '#9400D3'];

    const datasets = deductionTypes.map((type, index) => ({
      label: type.charAt(0).toUpperCase() + type.slice(1),
      data: employees.map(e => e.salary?.deductions?.[type] || 0),
      backgroundColor: rainbowColors[index % rainbowColors.length],
    }));

    const ctxRainbow = document.getElementById('rainbowChart')?.getContext('2d');
    if (ctxRainbow) {
      chartRefs.current.rainbow = new Chart(ctxRainbow, {
        type: 'bar',
        data: {
          labels: employees.map(e => `${e.firstName} ${e.lastName}`),
          datasets,
        },
        options: { responsive: true, scales: { x: { stacked: true }, y: { stacked: true, beginAtZero: true } } },
      });
    }
  };

  const handleAddEmployee = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = { employerId, ...Object.fromEntries(new FormData(e.target)) };
    try {
      await dispatch(addEmployee(formData)).unwrap();
      setIsModalOpen(false);
      toast.success('Employee added successfully!');
      dispatch(fetchEmployees({ id: employerId, userType: 'jobEmployer' }));
    } catch (error) {
      toast.error('Failed to add employee: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAddSalary = async (e) => {
    e.preventDefault();
    setSalaryLoading(prev => ({ ...prev, [selectedSalaryEmployee._id]: true }));
    const formData = { employerId, employeeId: selectedSalaryEmployee._id, ...salaryFormData };
    try {
      await dispatch(addSalary(formData)).unwrap();
      setIsSalaryModalOpen(false);
      setSalaryFormData({ grossSalary: '', tax: '', penalty: '', hmo: '', other: '' });
      toast.success('Salary added successfully!');
      dispatch(fetchEmployees({ id: employerId, userType: 'jobEmployer' }));
    } catch (error) {
      toast.error('Failed to add salary: ' + error.message);
    } finally {
      setSalaryLoading(prev => ({ ...prev, [selectedSalaryEmployee._id]: false }));
    }
  };

  const handleUpdateEmployee = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await dispatch(updateEmployee({ employerId, employeeId: editData._id, ...editData })).unwrap();
      setIsEditModalOpen(false);
      toast.success('Employee updated successfully!');
      dispatch(fetchEmployees({ id: employerId, userType: 'jobEmployer' }));
    } catch (error) {
      toast.error('Failed to update employee: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteEmployee = async (employeeId) => {
    if (window.confirm('Are you sure you want to delete this employee?')) {
      try {
        await dispatch(deleteEmployee({ employerId, employeeId })).unwrap();
        toast.success('Employee deleted successfully!');
        dispatch(fetchEmployees({ id: employerId, userType: 'jobEmployer' }));
      } catch (error) {
        toast.error('Failed to delete employee: ' + error.message);
      }
    }
  };

  const handleGeneratePayslip = (employee) => {
    setPayslipData(generatePayslipData(employee));
    setIsPayslipModalOpen(true);
  };

  const calculateBreakdown = (salary) => {
    const daily = (salary.netSalary || 0) / 30;
    const weekly = daily * 7;
    const monthly = salary.netSalary || 0;
    return { daily, weekly, monthly };
  };

  const attendanceEmployeeList = employees.map(emp => ({
    id: emp._id,
    name: `${emp.firstName} ${emp.lastName}` || `Employee ${emp._id.slice(-4)}`,
  }));

  const generatePayslipData = (employee, history = null) => {
    if (!employee?.salary) {
      return { employee: 'N/A', salary: { grossSalary: 0, deductions: {}, netSalary: 0 } };
    }
    if (history) {
      return {
        employee: `${employee.firstName} ${employee.lastName}`,
        salary: {
          grossSalary: history.grossSalary || 0,
          deductions: history.deductions || { tax: 0, penalty: 0, hmo: 0, other: 0 },
          netSalary: history.netSalary || 0,
        },
      };
    }
    const { gross, deductions, net, history: latestHistory } = employee.salary;
    const latest = latestHistory?.length ? latestHistory[latestHistory.length - 1] : {};
    return {
      employee: `${employee.firstName} ${employee.lastName}`,
      salary: {
        grossSalary: gross || latest.grossSalary || 0,
        deductions: deductions || latest.deductions || { tax: 0, penalty: 0, hmo: 0, other: 0 },
        netSalary: net || latest.netSalary || 0,
      },
    };
  };

  const handleSendPayslipEmail = async (employee) => {
    if (!employee?.email) {
      setNotification({ message: 'Employee email not available', type: 'error' });
      return;
    }

    setIsSending(true);
    setNotification({ message: '', type: '' });

    const payslipData = generatePayslipData(employee);
    const payslipText = `Payslip for ${payslipData.employee}\nGross: ₦${(payslipData.salary.grossSalary || 0).toLocaleString()}\nDeductions: ₦${Object.values(payslipData.salary.deductions || {})
      .reduce((a, b) => a + b, 0)
      .toLocaleString()}\nNet: ₦${(payslipData.salary.netSalary || 0).toLocaleString()}`;

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}payslip/send-email`,
        {
          recipient: employee.email,
          subject: `Payslip for ${payslipData.employee}`,
          body: payslipText,
          employeeId: employee._id,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
      );
      setNotification({ message: 'Payslip sent via email successfully', type: 'success' });
    } catch (err) {
      console.error('Error sending payslip email:', err);
      setNotification({ message: err.message || 'Failed to send payslip via email', type: 'error' });
    } finally {
      setIsSending(false);
    }
  };

  const handleSendPayslip = async () => {
    if (!selectedEmployee || !recipient || !sendMethod) {
      setNotification({ message: 'Please provide a recipient and select a method', type: 'error' });
      return;
    }

    setIsSending(true);
    const payslipData = generatePayslipData(selectedEmployee);
    const payslipText = `Payslip for ${payslipData.employee}\nGross: ₦${(payslipData.salary.grossSalary || 0).toLocaleString()}\nDeductions: ₦${Object.values(payslipData.salary.deductions || {})
      .reduce((a, b) => a + b, 0)
      .toLocaleString()}\nNet: ₦${(payslipData.salary.netSalary || 0).toLocaleString()}`;

    try {
      if (sendMethod === 'email') {
        await axios.post(
          '/api/payslip/send-email',
          {
            recipient,
            subject: `Payslip for ${payslipData.employee}`,
            body: payslipText,
            employeeId: selectedEmployee._id,
          },
          {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          }
        );
        setNotification({ message: 'Payslip sent via email successfully', type: 'success' });
      } else if (sendMethod === 'whatsapp' || sendMethod === 'sms') {
        const kudiSMSResponse = await axios.post(
          'https://api.kudisms.net/v1/sms/send',
          {
            public_key: process.env.REACT_APP_KUDISMS_PUBLIC_KEY,
            secret_key: process.env.REACT_APP_KUDISMS_SECRET_KEY,
            recipient,
            message: sendMethod === 'whatsapp' ? payslipText : `Payslip: ${payslipText}`,
            sender_id: 'YourBusinessName',
            type: sendMethod === 'whatsapp' ? 'whatsapp' : 'sms',
          },
          {
            headers: { 'Content-Type': 'application/json' },
          }
        );

        if (kudiSMSResponse.data.status === 'success') {
          setNotification({ message: `Payslip sent via ${sendMethod} successfully`, type: 'success' });
        } else {
          throw new Error('KudiSMS API error');
        }
      }
    } catch (err) {
      console.error(`Error sending payslip via ${sendMethod}:`, err);
      setNotification({ message: `Failed to send payslip via ${sendMethod}`, type: 'error' });
    } finally {
      setIsSending(false);
      setIsSendPayslipModalOpen(false);
      setRecipient('');
      setSendMethod('');
      setSelectedEmployee(null);
    }
  };

  useEffect(() => {
    if (notification.message) {
      const timer = setTimeout(() => {
        setNotification({ message: '', type: '' });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  // Calculate overview stats
  const totalEmployees = employees.length;
  const totalPayroll = employees.reduce((sum, e) => sum + (e.salary?.net || 0), 0);
  const averageSalary = totalEmployees > 0 ? totalPayroll / totalEmployees : 0;
  const pendingLeaves = employees.reduce((sum, e) => sum + (e.leaveRequests?.filter(l => l.status === 'Pending').length || 0), 0);

  return (
    <div className="min-h-screen mt-20 bg-gradient-to-br from-gray-100 to-gray-200 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-8">

          <button
            onClick={() => setIsModalOpen(true)}
            className="bg-indigo-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-indigo-700 transition-colors flex items-center gap-2"
          >
            <BiPlus size={20} /> Add Employee
          </button>
        </div>

        {/* Overview Stats Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-white p-6 rounded-xl shadow-lg flex flex-col items-center">
            <h3 className="text-lg font-semibold text-gray-700">Total Employees</h3>
            <p className="text-3xl font-bold text-indigo-600">{totalEmployees}</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg flex flex-col items-center">
            <h3 className="text-lg font-semibold text-gray-700">Total Monthly Payroll</h3>
            <p className="text-3xl font-bold text-green-600">₦{totalPayroll.toLocaleString()}</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg flex flex-col items-center">
            <h3 className="text-lg font-semibold text-gray-700">Average Salary</h3>
            <p className="text-3xl font-bold text-blue-600">₦{averageSalary.toLocaleString()}</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg flex flex-col items-center">
            <h3 className="text-lg font-semibold text-gray-700">Pending Leaves</h3>
            <p className="text-3xl font-bold text-red-600">{pendingLeaves}</p>
          </div>
        </div>

        {/* Charts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Employee Distribution (Pie Chart)</h3>
            <div className="h-80">
              <canvas id="staffChart"></canvas>
            </div>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Total Salaries (Bar Chart)</h3>
            <div className="h-80">
              <canvas id="salaryBarChart"></canvas>
            </div>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Average Salary Breakdown (Waterfall Chart)</h3>
            <div className="h-80">
              <canvas id="waterfallChart"></canvas>
            </div>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Salary Trends (Line Chart)</h3>
            <div className="h-80">
              <canvas id="lineChart"></canvas>
            </div>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg md:col-span-2">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Deductions Breakdown (Rainbow Stacked Bar)</h3>
            <div className="h-80">
              <canvas id="rainbowChart"></canvas>
            </div>
          </div>
        </div>

        {/* Attendance Component */}
        <div className="bg-white p-6 rounded-xl shadow-lg mb-8">
          <h3 className="text-xl font-semibold mb-4 text-gray-800">Employee Attendance</h3>
          <EmployerAttendance employeeList={attendanceEmployeeList} />
        </div>

        {/* Employees Table */}
        <div className="bg-white p-6 rounded-xl shadow-lg mb-8 overflow-x-auto">
          <h3 className="text-xl font-semibold mb-4 text-gray-800">Employed Workers & Salaries</h3>
          <table className="w-full text-left text-sm md:text-base">
            <thead className="bg-indigo-100 text-indigo-800">
              <tr>
                <th className="py-3 px-6">Name</th>
                <th className="py-3 px-6">Email</th>
                <th className="py-3 px-6">Latest Net Salary</th>
                <th className="py-3 px-6">Actions</th>
              </tr>
            </thead>
            <tbody>
              {employees.map(employee => (
                <tr key={employee._id} className="border-b hover:bg-gray-50">
                  <td className="py-3 px-6">{employee.firstName} {employee.lastName}</td>
                  <td className="py-3 px-6">{employee.email}</td>
                  <td className="py-3 px-6">₦{(employee.salary?.history[employee.salary?.history.length - 1]?.netSalary || 0).toLocaleString()}</td>
                  <td className="py-3 px-6 flex gap-2">
                    <button onClick={() => { setSelectedEmployee(employee); setEditData(employee); setIsEditModalOpen(true); }} className="text-indigo-600 hover:text-indigo-800"><BiEdit size={20} /></button>
                    <button onClick={() => handleDeleteEmployee(employee._id)} className="text-red-600 hover:text-red-800"><BiTrash size={20} /></button>
                    <button onClick={() => handleGeneratePayslip(employee)} className="text-green-600 hover:text-green-800"><BiDownload size={20} /></button>
                    <button onClick={() => { setSelectedSalaryEmployee(employee); setIsSalaryModalOpen(true); }} className="text-purple-600 hover:text-purple-800"><BiDollar size={20} /></button>
                    <button onClick={() => { setSelectedHistoryEmployee(employee); setIsSalaryHistoryModalOpen(true); }} className="text-teal-600 hover:text-teal-800"><BiSearch size={20} /></button>
                    <button onClick={() => handleSendPayslipEmail(employee)} disabled={isSending} className={`text-blue-600 hover:text-blue-800 ${isSending ? 'opacity-50' : ''}`}><BiEnvelope size={20} /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Modals */}
        {isModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-white p-8 rounded-xl max-h-[500px] overflow-y-auto shadow-2xl w-full max-w-lg transform scale-100 transition-transform">
              <div className="flex justify-between items-center mb-6 sticky top-0 bg-white z-10">
                <h3 className="text-2xl font-bold text-gray-800">Add New Employee</h3>
                <button onClick={() => setIsModalOpen(false)} className="text-gray-500 hover:text-gray-700">
                  <BiX size={28} />
                </button>
              </div>
              <form onSubmit={handleAddEmployee} className="space-y-4">
                <input name="firstName" placeholder="First Name" required className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="lastName" placeholder="Last Name" required className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="email" placeholder="Email" required className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="gender" placeholder="Gender" required className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="middleName" placeholder="Middle Name" className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="dateOfBirth" placeholder="Date of Birth" className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="address" placeholder="Address" className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="phoneNumber" placeholder="Phone Number" className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="TIN" placeholder="TIN" className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <select name="TINType" className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500">
                  <option value="" disabled>Select TIN type</option>
                  {tinTypes.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </select>
                <input name="whatsappNumber" placeholder="WhatsApp Number" className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-indigo-600 text-white p-3 rounded-lg hover:bg-indigo-700 transition-colors flex items-center justify-center gap-2"
                >
                  {loading ? (
                    <>
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                      Adding...
                    </>
                  ) : 'Add Employee'}
                </button>
              </form>
            </div>
          </div>
        )}

        {isEditModalOpen && selectedEmployee && (
  <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-white p-8 rounded-xl max-h-[500px] overflow-y-auto shadow-2xl w-full max-w-lg transform scale-100 transition-transform">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-gray-800">Edit Employee</h3>
                <button onClick={() => setIsEditModalOpen(false)} className="text-gray-500 hover:text-gray-700">
                  <BiX size={28} />
                </button>
              </div>
              <form onSubmit={handleUpdateEmployee} className="space-y-4">
                <input name="firstName" value={editData.firstName || ''} onChange={(e) => setEditData({ ...editData, firstName: e.target.value })} required className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="lastName" value={editData.lastName || ''} onChange={(e) => setEditData({ ...editData, lastName: e.target.value })} required className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="email" value={editData.email || ''} onChange={(e) => setEditData({ ...editData, email: e.target.value })} required className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="gender" value={editData.gender || ''} onChange={(e) => setEditData({ ...editData, gender: e.target.value })} required className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="middleName" value={editData.middleName || ''} onChange={(e) => setEditData({ ...editData, middleName: e.target.value })} className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="dateOfBirth" value={editData.dateOfBirth || ''} onChange={(e) => setEditData({ ...editData, dateOfBirth: e.target.value })} className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="address" value={editData.address || ''} onChange={(e) => setEditData({ ...editData, address: e.target.value })} className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="phoneNumber" value={editData.phoneNumber || ''} onChange={(e) => setEditData({ ...editData, phoneNumber: e.target.value })} className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <select
                  value={editData.TINType || ''}
                  onChange={(e) => setEditData({ ...editData, TINType: e.target.value })}
                  name="TINType"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                  <option value="" disabled>Select TIN type</option>
                  {tinTypes.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </select>
                <input name="TIN" value={editData.TIN || ''} onChange={(e) => setEditData({ ...editData, TIN: e.target.value })} className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <input name="whatsappNumber" value={editData.whatsappNumber || ''} onChange={(e) => setEditData({ ...editData, whatsappNumber: e.target.value })} className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-yellow-500 text-white p-3 rounded-lg hover:bg-yellow-600 transition-colors flex items-center justify-center gap-2"
                >
                  {loading ? (
                    <>
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                      Updating...
                    </>
                  ) : 'Update Employee'}
                </button>
              </form>
            </div>
          </div>
        )}

        {isPayslipModalOpen && payslipData.employee && (
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-lg">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-gray-800">Payslip</h3>
                <button onClick={() => setIsPayslipModalOpen(false)} className="text-gray-500 hover:text-gray-700">
                  <BiX size={28} />
                </button>
              </div>
              <div className="space-y-4 text-gray-700">
                <p><strong>Employee:</strong> {payslipData.employee}</p>
                <p><strong>Gross Salary:</strong> ₦{payslipData.salary.grossSalary.toLocaleString()}</p>
                <p><strong>Deductions:</strong> ₦{Object.values(payslipData.salary.deductions || {}).reduce((a, b) => a + b, 0).toLocaleString()}</p>
                <p><strong>Net Salary:</strong> ₦{payslipData.salary.netSalary.toLocaleString()}</p>
                <div>
                  <strong>Breakdown:</strong>
                  <table className="w-full mt-2 border-collapse">
                    <thead className="bg-gray-100">
                      <tr><th className="py-2 px-4 border">Type</th><th className="py-2 px-4 border">Amount</th></tr>
                    </thead>
                    <tbody>
                      {Object.entries(calculateBreakdown(payslipData.salary)).map(([type, amount]) => (
                        <tr key={type} className="border-t">
                          <td className="py-2 px-4 border capitalize">{type}</td>
                          <td className="py-2 px-4 border">₦{amount.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <button
                  onClick={() => {
                    const element = document.createElement('a');
                    const file = new Blob([`Payslip for ${payslipData.employee}\nGross: ₦${payslipData.salary.grossSalary.toLocaleString()}\nDeductions: ₦${Object.values(payslipData.salary.deductions || {}).reduce((a, b) => a + b, 0).toLocaleString()}\nNet: ₦${payslipData.salary.netSalary.toLocaleString()}`], { type: 'text/plain' });
                    element.href = URL.createObjectURL(file);
                    element.download = `payslip_${payslipData.employee.replace(/ /g, '_')}.txt`;
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                  }}
                  className="w-full bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2"
                >
                  <BiDownload size={20} /> Download Payslip
                </button>
              </div>
            </div>
          </div>
        )}

        {isSalaryModalOpen && selectedSalaryEmployee && (
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-lg">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-gray-800">Add Salary for {selectedSalaryEmployee.firstName} {selectedSalaryEmployee.lastName}</h3>
                <button onClick={() => setIsSalaryModalOpen(false)} className="text-gray-500 hover:text-gray-700">
                  <BiX size={28} />
                </button>
              </div>
              <form onSubmit={handleAddSalary} className="space-y-4">
                <input
                  name="grossSalary"
                  value={salaryFormData.grossSalary}
                  onChange={(e) => setSalaryFormData({ ...salaryFormData, grossSalary: e.target.value })}
                  placeholder="Gross Salary"
                  type="number"
                  required
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
                <input
                  name="tax"
                  value={salaryFormData.tax}
                  onChange={(e) => setSalaryFormData({ ...salaryFormData, tax: e.target.value })}
                  placeholder="Tax"
                  type="number"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
                <input
                  name="penalty"
                  value={salaryFormData.penalty}
                  onChange={(e) => setSalaryFormData({ ...salaryFormData, penalty: e.target.value })}
                  placeholder="Penalty"
                  type="number"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
                <input
                  name="hmo"
                  value={salaryFormData.hmo}
                  onChange={(e) => setSalaryFormData({ ...salaryFormData, hmo: e.target.value })}
                  placeholder="HMO"
                  type="number"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
                <input
                  name="other"
                  value={salaryFormData.other}
                  onChange={(e) => setSalaryFormData({ ...salaryFormData, other: e.target.value })}
                  placeholder="Other Deductions"
                  type="number"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
                <button
                  type="submit"
                  disabled={salaryLoading[selectedSalaryEmployee._id]}
                  className="w-full bg-indigo-600 text-white p-3 rounded-lg hover:bg-indigo-700 transition-colors flex items-center justify-center gap-2"
                >
                  {salaryLoading[selectedSalaryEmployee._id] ? (
                    <>
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                      Adding...
                    </>
                  ) : 'Add Salary'}
                </button>
              </form>
            </div>
          </div>
        )}

        {isSalaryHistoryModalOpen && selectedHistoryEmployee && (
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-3xl">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-gray-800">Salary History & Breakdown for {selectedHistoryEmployee.firstName} {selectedHistoryEmployee.lastName}</h3>
                <button onClick={() => setIsSalaryHistoryModalOpen(false)} className="text-gray-500 hover:text-gray-700">
                  <BiX size={28} />
                </button>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div>
                  <h4 className="text-lg font-semibold mb-2 text-gray-800">Salary History</h4>
                  <table className="w-full text-sm border-collapse">
                    <thead className="bg-gray-100">
                      <tr><th className="py-2 px-4 border">Period</th><th className="py-2 px-4 border">Gross</th><th className="py-2 px-4 border">Deductions</th><th className="py-2 px-4 border">Net</th></tr>
                    </thead>
                    <tbody>
                      {selectedHistoryEmployee.salary.history.map((hist, i) => (
                        <tr key={i} className="border-t">
                          <td className="py-2 px-4 border">{hist.month} {hist.year}</td>
                          <td className="py-2 px-4 border">₦{hist.grossSalary.toFixed(2)}</td>
                          <td className="py-2 px-4 border">₦{Object.values(hist.deductions).reduce((a, b) => a + b, 0).toFixed(2)}</td>
                          <td className="py-2 px-4 border">₦{hist.netSalary.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div>
                  <h4 className="text-lg font-semibold mb-2 text-gray-800">Breakdown</h4>
                  <table className="w-full text-sm border-collapse">
                    <thead className="bg-gray-100">
                      <tr><th className="py-2 px-4 border">Type</th><th className="py-2 px-4 border">Amount</th></tr>
                    </thead>
                    <tbody>
                      {Object.entries(calculateBreakdown(selectedHistoryEmployee.salary.history[selectedHistoryEmployee.salary.history.length - 1] || {})).map(([type, amount]) => (
                        <tr key={type} className="border-t">
                          <td className="py-2 px-4 border capitalize">{type}</td>
                          <td className="py-2 px-4 border">₦{amount.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Per Employee Details */}
        <div className="space-y-6">
          {employees.map(employee => (
            <div key={employee._id} className="bg-white p-6 rounded-xl shadow-lg">
              <h3 className="text-xl font-bold mb-4 text-gray-800">{employee.firstName} {employee.lastName} - Details</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <h4 className="text-lg font-semibold mb-2 text-gray-700">Salary History</h4>
                  <table className="w-full text-sm border-collapse">
                    <thead className="bg-gray-100">
                      <tr><th className="py-2 px-4 border">Period</th><th className="py-2 px-4 border">Gross</th><th className="py-2 px-4 border">Deductions</th><th className="py-2 px-4 border">Net</th></tr>
                    </thead>
                    <tbody>
                      {employee.salary?.history.map((hist, i) => (
                        <tr key={i} className="border-t">
                          <td className="py-2 px-4 border">{hist.month} {hist.year}</td>
                          <td className="py-2 px-4 border">₦{hist.grossSalary.toFixed(2)}</td>
                          <td className="py-2 px-4 border">₦{Object.values(hist.deductions).reduce((a, b) => a + b, 0).toFixed(2)}</td>
                          <td className="py-2 px-4 border">₦{hist.netSalary.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div>
                  <h4 className="text-lg font-semibold mb-2 text-gray-700">Salary Breakdown</h4>
                  <table className="w-full text-sm border-collapse">
                    <thead className="bg-gray-100">
                      <tr><th className="py-2 px-4 border">Type</th><th className="py-2 px-4 border">Amount</th></tr>
                    </thead>
                    <tbody>
                      {Object.entries(calculateBreakdown(employee.salary?.history[employee.salary?.history.length - 1] || {})).map(([type, amount]) => (
                        <tr key={type} className="border-t">
                          <td className="py-2 px-4 border capitalize">{type}</td>
                          <td className="py-2 px-4 border">₦{amount.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <h4 className="text-lg font-semibold mb-2 text-gray-700">Leave History</h4>
              <table className="w-full text-sm border-collapse">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="py-2 px-4 border text-left">Start Date</th>
                    <th className="py-2 px-4 border text-left">End Date</th>
                    <th className="py-2 px-4 border text-left">Reason</th>
                    <th className="py-2 px-4 border text-left">Status</th>
                    <th className="py-2 px-4 border text-left">Actions</th>
                    <th className="py-2 px-4 border text-left">Others</th>
                  </tr>
                </thead>
                <tbody>
                  {employee.leaveRequests?.map(leave => (
                    <tr key={leave._id} className="border-t">
                      <td className="py-2 px-4 border">{new Date(leave.startDate).toLocaleDateString()}</td>
                      <td className="py-2 px-4 border">{new Date(leave.endDate).toLocaleDateString()}</td>
                      <td className="py-2 px-4 border">{leave.reason}</td>
                      <td className="py-2 px-4 border">{leave.status}</td>
                      <td className="py-2 px-4 border">
                        {leave.status === 'Pending' && (
                          <>
                            <button onClick={() => dispatch(approveLeave({ employerId, employeeId: employee._id, leaveId: leave._id })).unwrap().then(() => toast.success('Leave approved!'))} className="text-green-600 hover:text-green-800 mr-2"><BiCheck size={20} /></button>
                            <button onClick={() => dispatch(rejectLeave({ employerId, employeeId: employee._id, leaveId: leave._id })).unwrap().then(() => toast.success('Leave rejected!'))} className="text-red-600 hover:text-red-800"><BiX size={20} /></button>
                          </>
                        )}
                      </td>
                      <td className="py-2 px-4 border">{leave.others}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>

        {/* Notification */}
        {notification.message && (
          <div
            className={`fixed top-6 right-6 p-4 rounded-lg shadow-lg text-white z-50 ${
              notification.type === 'success' ? 'bg-green-500' : 'bg-red-500'
            }`}
          >
            {notification.message}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployerEmployee;